module.exports = __webpack_public_path__ + "img/dibu.583421cc.png";